// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GridTable_grid__F3alc {
  display: grid;
  min-width: fit-content;
  overflow-x: clip;
}

.GridTable_cell__A\\+aP\\+ {
  display: flex;
  height: 100%;
  gap: 4px;
  min-height: 32px;
  padding: 2px 4px;
  align-items: center;
  color: black;
}
.GridTable_cell__A\\+aP\\+[data-even-row=true] {
  background-color: #f8f8f8;
}
.GridTable_cell__A\\+aP\\+[data-gray-row=true] {
  color: gray;
}
.GridTable_cell__A\\+aP\\+[data-hover-row=true] {
  background-color: #eee;
}
.GridTable_cell__A\\+aP\\+[data-selected=true] {
  background-color: #e0e0e0;
}

.GridTable_header__4XayJ {
  height: 4rem;
  border-bottom: 1px solid #dee2e6;
  font-weight: bold;
}
.GridTable_header__4XayJ button {
  background-color: white;
  width: 2rem;
  height: 2rem;
  border-radius: 2px;
}
.GridTable_header__4XayJ button:hover {
  border: 1px solid black;
}
.GridTable_header__4XayJ[data-compact=true] {
  height: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Table/GridTable.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AACF;AACE;EACE,yBAAA;AACJ;AACE;EACE,WAAA;AACJ;AACE;EACE,sBAAA;AACJ;AACE;EACE,yBAAA;AACJ;;AAGA;EACE,YAAA;EACA,gCAAA;EACA,iBAAA;AAAF;AAEE;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;AAEI;EACE,uBAAA;AAAN;AAIE;EACE,YAAA;AAFJ","sourcesContent":[".grid {\n  display: grid;\n  min-width: fit-content;\n  overflow-x: clip;\n}\n\n.cell {\n  display: flex;\n  height: 100%;\n  gap: 4px;\n  min-height: 32px;\n  padding: 2px 4px;\n  align-items: center;\n  color: black;\n}\n.cell[data-even-row=true] {\n  background-color: #f8f8f8;\n}\n.cell[data-gray-row=true] {\n  color: gray;\n}\n.cell[data-hover-row=true] {\n  background-color: #eee;\n}\n.cell[data-selected=true] {\n  background-color: #e0e0e0;\n}\n\n.header {\n  height: 4rem;\n  border-bottom: 1px solid #dee2e6;\n  font-weight: bold;\n}\n.header button {\n  background-color: white;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 2px;\n}\n.header button:hover {\n  border: 1px solid black;\n}\n.header[data-compact=true] {\n  height: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `GridTable_grid__F3alc`,
	"cell": `GridTable_cell__A+aP+`,
	"header": `GridTable_header__4XayJ`
};
export default ___CSS_LOADER_EXPORT___;
